import { slotDefinition } from "../configs/slotDefinition.config.js";
import { openPopup } from "./helpers/openPopup.js";

export async function info(scope, ctx) {
    const { scenes, hud, gameLogic } = ctx;

    hud.setPopupState();

    const popup = await openPopup(scope, scenes, "InfoPopupScene", {
        paytable: slotDefinition.paytable,
        bet: gameLogic.bet,
        currency: "FUN",
    });

    await scope.wait(popup.onPressClose);
}
